import { render } from "./TagManagement.vue?vue&type=template&id=7787faf8&scoped=true"
import script from "./TagManagement.vue?vue&type=script&lang=js"
export * from "./TagManagement.vue?vue&type=script&lang=js"

import "./TagManagement.vue?vue&type=style&index=0&id=7787faf8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7787faf8"]])

export default __exports__